
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class CopyLayerToOthersModal extends Vue {

    @Prop() layerList: OM.LayerComposition[];
    @Prop() rawMaterialTransportPhases: { [key: string]: OM.TransportProductionPhase[]; };
    @Prop() productionPhase: string;
    @Prop() layer: OM.LayerComposition;

    @Prop() saveCallback: (selectedLayersToCopy: string[]) => void;

    selectedLayersToCopy: string[] = [];

    created() {}

    get disabled() {
        return this.selectedLayersToCopy.length == 0;
    }

    toggleLayerFromList(item: string) {
        var existingIndex = this.selectedLayersToCopy.indexOf(item);
        if(existingIndex == -1)
            this.selectedLayersToCopy.push(item);
        else
            this.selectedLayersToCopy.splice(existingIndex, 1);
    }

    save() {
        this.saveCallback(this.selectedLayersToCopy);
    }
}
